import React from "react";
import { FaQuoteLeft } from "react-icons/fa";

const TestimonialsSection = ({ reviews = [] }) => {
  return (
    <section
      id="testimonials"
      className="py-20 bg-gradient-to-r from-blue-50 via-white to-indigo-50 dark:from-gray-800 dark:via-gray-900 dark:to-gray-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-16 text-center relative">
        {/* Section Heading */}
        <h2 className="text-5xl font-extrabold text-gray-900 dark:text-white mb-12">
          What People Say
        </h2>

        {/* Testimonials Grid */}
        {reviews.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {reviews.map((review, index) => (
              <div
                key={index}
                className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg transform transition duration-500 hover:scale-105 hover:shadow-2xl"
              >
                <FaQuoteLeft className="text-indigo-500 dark:text-indigo-400 text-4xl mb-4" />
                <p className="text-lg italic text-gray-700 dark:text-gray-300 mb-6">
                  "{review.review}"
                </p>
                <h4 className="text-xl font-bold text-gray-900 dark:text-white">
                  {review.personName}
                </h4>
                <p className="text-gray-600 dark:text-gray-400">{review.influence}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600 dark:text-gray-400">No reviews available yet.</p>
        )}
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-purple-300 to-indigo-400 rounded-full opacity-30 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-gradient-to-br from-purple-300 to-indigo-400 rounded-full opacity-30 blur-3xl pointer-events-none"></div>
    </section>
  );
};

export default TestimonialsSection;

